import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';
import moment from 'moment';

@Component({
  selector: 'zbp-product-event-notification-modal',
  templateUrl: './product-event-notification-modal.component.html',
  styleUrls: ['./product-event-notification-modal.component.scss'],
  standalone: false
})
export class ProductEventNotificationModalComponent implements OnInit {
  @Input() eventHistoryId: string;
  @Input() whereChangesWereMade: string;
  @Input() title: string;
  @Input() firstName: string;
  @Input() lastName: string;
  @Input() changeDateTime: Date;
  dateForDisplay: string;
  timeForDisplay: string;

  readonly iconNames = zbpIconNames;

  constructor(public activeModal: NgbActiveModal) {}

  dismiss(): void {
    this.activeModal.dismiss();
  }

  confirm(): void {
    console.log('confirmed clicked...');
    this.activeModal.close(true);
  }

  ngOnInit(): void {
    this.dateForDisplay = moment(this.changeDateTime).format('MMM DD, YYYY');
    this.timeForDisplay = moment(this.changeDateTime).format('hh:mm A');
  }
}
